Auth = require 'db/auth'
CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
CustomSticker = require 'models/custom-sticker'

module.exports = class CustomStickerList extends CollectionWithHelpers
  model: CustomSticker
  url: -> "/1/member/#{ Auth.me().id }/customStickers"

  initialize: (list, { @member }) ->



// WEBPACK FOOTER //
// ./app/scripts/models/collections/custom-sticker-list.coffee